module.exports = __webpack_public_path__ + "img/cqyx.d1882f99.jpg";